/**
 * @import { AnsiPalette } from '../ansi.types.js'
 */

/** @type {AnsiPalette} */
export default {
  foreground: '#FFFFFF',
  background: '#000000',
  'background-hover': '#1E1E1E',
  'background-selected': '#2B2B2B',
  black: '#000000',
  red: '#FF4040',
  green: '#90AF7D',
  yellow: '#FFFF66',
  blue: '#9999FF',
  magenta: '#FF4BB9',
  cyan: '#3AEEE0',
  white: '#FFFFFF',
  'bright-black': '#BBBBBB',
  'bright-red': '#FF4040',
  'bright-green': '#90AF7D',
  'bright-yellow': '#FFFF66',
  'bright-blue': '#9999FF',
  'bright-magenta': '#FF4BB9',
  'bright-cyan': '#3AEEE0',
  'bright-white': '#FFFFFF',
};
